let authToken: string | null = null;
const refreshTokenKey = "refresh_token";

const getStoredRefreshToken = (): string | null => {
  const sessionRefreshToken = sessionStorage.getItem(refreshTokenKey);
  if (sessionRefreshToken) return sessionRefreshToken;

  const legacyRefreshToken = localStorage.getItem(refreshTokenKey);
  if (!legacyRefreshToken) return null;

  sessionStorage.setItem(refreshTokenKey, legacyRefreshToken);
  localStorage.removeItem(refreshTokenKey);
  localStorage.removeItem("auth_token");
  return legacyRefreshToken;
};

export const getHasJWT = (): boolean => !!authToken || !!getStoredRefreshToken();
export const getJWT = (): string | null => authToken;
export const setJWT = (newAuthToken: string): void => {
  authToken = newAuthToken || null;
};

export const getHasRefreshToken = (): boolean => !!getRefreshToken();
export const getRefreshToken = (): string | null =>
  getStoredRefreshToken();
export const setRefreshToken = (refreshToken: string): void => {
  if (!refreshToken) {
    sessionStorage.removeItem(refreshTokenKey);
    localStorage.removeItem(refreshTokenKey);
    localStorage.removeItem("auth_token");
    return;
  }

  sessionStorage.setItem(refreshTokenKey, refreshToken);
  localStorage.removeItem(refreshTokenKey);
  localStorage.removeItem("auth_token");
};
